import { useState } from "react";
import { HeaderNav } from "@/components/HeaderNav";
import { KineticHero } from "@/components/KineticHero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { PricingTiers } from "@/components/PricingTiers";
import { NumberedChapters } from "@/components/NumberedChapters";
import { CashAppSection } from "@/components/CashAppSection";
import { BookingSection } from "@/components/BookingSection";
import { FooterSection } from "@/components/FooterSection";

export default function LandingPage() {
  const [selectedPackage, setSelectedPackage] = useState("basic");

  return (
    <div className="bg-[#FAF9F5]" data-testid="landing-page">
      <HeaderNav />
      <main>
        <KineticHero />
        <EditorialMarquee />
        <PricingTiers onSelectPackage={setSelectedPackage} />
        <NumberedChapters />
        <CashAppSection />
        <BookingSection selectedPackage={selectedPackage} setSelectedPackage={setSelectedPackage} />
      </main>
      <FooterSection />
    </div>
  );
}
